/** Marken-Kopf: Logo-Icon (oranger „S"-Kreis) + Wortmarke „Sentinus / KI-Kurs". */
import { useEffect } from "preact/hooks";
import { useLocation } from "preact-iso";
import { assetUrl } from "../data/assets";
import { isAuthenticated } from "../state/session";
import { loadQuota, monthUsagePct, quotaError } from "../state/quota";

/**
 * Kompakter Kontingent-Balken (Web-Parität, public/assets/app.js →
 * aktualisiereTokenBalken): zeigt nur eingeloggt das verbrauchte KI-Kontingent
 * (Monatsfenster) als Prozent-Balken. Tap führt zu den Details im Profil.
 * Bei fehlendem Token / Fehler bleibt der Balken einfach unsichtbar.
 */
export function TokenBalken() {
  const { route } = useLocation();

  useEffect(() => {
    if (isAuthenticated.value) loadQuota();
  }, []);

  if (!isAuthenticated.value) return null;
  // Bei einem Lade-/Quota-Fehler (z. B. 429) keinen veralteten Wert stehen lassen
  // (Codex-Review): lieber Balken ausblenden als falschen Prozentwert zeigen.
  if (quotaError.value) return null;
  const pct = monthUsagePct.value;
  if (pct === null) return null;

  const rounded = Math.round(pct);
  return (
    <button
      type="button"
      class={`token-balken${pct >= 100 ? " voll" : ""}`}
      title={`Verbrauchtes KI-Kontingent: ${rounded} % (Details im Profil)`}
      aria-label={`Verbrauchtes KI-Kontingent: ${rounded} Prozent. Tippen für Details im Profil.`}
      onClick={() => route("/profil")}
    >
      <span class="token-balken-track">
        <i style={`width:${pct.toFixed(1)}%`} />
      </span>
    </button>
  );
}

export function BrandHeader({ center = true }: { center?: boolean }) {
  return (
    <div class="brand-header">
      <div class="brand" style={center ? "justify-content:center" : undefined}>
        <img class="brand-logo" src={assetUrl("logo-icon.png") ?? "/icons/icon.svg"} alt="Sentinus" />
        <span class="brand-text">
          <strong>Sentinus</strong>
          <small>KI-Kurs</small>
        </span>
      </div>
      <TokenBalken />
    </div>
  );
}
